import { POSITION_START} from './positionStartTypes'

const initialState = {
    positionStart: ""
}

const positionStartReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case POSITION_START:
            
            return {
                positionStart: action.load
            }
    
        default:
          return state
    }

}


export default positionStartReducer;